import { useState } from "react";
import Required from "../../../common-components/Required";
import { useDispatch, useSelector } from "react-redux";
import {
  fileDelete,
  fileUpload,
  previewImage,
  progressPercentage,
  setSelectedFile,
} from "../../../../slices/FileUploadSlice";
import FileUploader from "../../../common-components/FileUploader";
import CloseButton from "../../../custom-components/CloseButton";
import CancelButton from "../../../custom-components/CancelButton";
import BlackButton from "../../../custom-components/BlackButton";
import { ConciergeStringLabels } from "../../../../util/Strings";
import ImagePreviewWithFilename from "../../../common-components/ImagePreviewWithFilename";
import ErrorMessageComponent from "../../../common-components/ErrorMessageComponent";
import useFileValidation from "../../../../util/useFileValidation";
import ErrorAlert from "../../../common-components/ErrorAlert";
import ErrorMessages from "../../../../util/ErrorMessages";
import {
  setPreThumbnailId,
  setPrevThumbnailDetails,
} from "../../../../slices/ConciergeSlice";
import { NewConciergeFormValidations } from "../../../../util/Validations";

function AddConciergeForm({ show, onClickNext, data, disableFields = false }) {
  console.log("disableFields value:", disableFields);
  const dispatch = useDispatch();
  const fileUploadId = useSelector((state) => state.upload.id);
  const [state, setState] = useState({
    firstName: data?.firstName || "",
    lastName: data?.lastName || "",
    email: data?.email || "",
    ccEmails: data?.ccEmails || "",
    aboutMe: data?.aboutMe || "",
    photoId: data?.photoId || null,
  });
  const [prevFileData, setPreFileData] = useState({
    photoUrl: data?.photoUrl || null,
    fileName: data?.fileName || null,
  });
  const [prevFileId, setPrevFileId] = useState(data?.photoId || null);
  const prevImageId = useSelector((state) => state.concierge.prevThumbnailId);
  const [validation, setValidation] = useState({});
  const { errorSingleMessage, setErrorSingleMessage, validateFile } =
    useFileValidation();
  const [photoUrl, setPhotoUrl] = useState(null);
  const [imageDeleteList, setImageDeleteList] = useState([]);

  function handleChange(e) {
    let value = e.target.value;
    if (e.target.name === "email") {
      value = value.toLowerCase();
    }
    setState({
      ...state,
      [e.target.name]: value,
    });
  }

  const resetPrevFileData = useSelector(
    (state) => state.concierge.prevThumbnailDetails
  );

  const errorMessageCode = useSelector((state) => state.upload.errorCode);

  function handleImageCancel() {
    setState({
      ...state,
      photoId: null,
    });
    setPreFileData({ photoUrl: null, fileName: null });
    setImageDeleteList([...imageDeleteList, prevFileId]);
  }

  function handleCloseErrorAlert() {
    setPreFileData(resetPrevFileData);
    handleState();
    dispatch(setSelectedFile(null));
    setImageDeleteList([]);
    onClickNext();
  }

  function resetImage() {
    dispatch(progressPercentage(0));
    dispatch(setSelectedFile(null));
    dispatch(previewImage(null));
  }

  function handleState() {
    setState((prev) => ({ ...prev, photoId: data?.photoId || null }));
  }

  const checkValidation = () => {
    const { errors, isValid } = NewConciergeFormValidations(state ,disableFields);
    setValidation(errors);
    return isValid;
  };

  function handleCreateButton() {
    if (checkValidation()) {
      // Condition for required fields on submit
      if (state.firstName && state.email && (!disableFields ? (state.aboutMe && state.ccEmails !== undefined) : true)) {
        resetImage();

        if (data) {
          // Updating existing concierge
          const newData = {
            firstName: state.firstName,
            lastName: state.lastName,
            email: state.email,
            aboutMe: state.aboutMe,
            photoId: state.photoId,
            ccEmails: state.ccEmails,
          };

          imageDeleteList.forEach((image) => {
            dispatch(fileDelete({ id: image }));
          });

          setPhotoUrl(null);
          onClickNext(newData);

          if (state.photoId !== prevImageId && prevImageId !== "") {
            const id = { id: prevImageId, isVideo: false };
            dispatch(fileDelete(id));
            dispatch(setPreThumbnailId(""));
          }

          setPreFileData({
            photoUrl: data?.photoUrl || null,
            fileName: data?.fileName || null,
          });
          setErrorSingleMessage("");
        } else {
          // Adding new concierge
          setState({});
          setPhotoUrl(null);
          setImageDeleteList([]);
          onClickNext(state);
        }
      } else {
        onClickNext();
      }
    }
  }

  if (!show) {
    return null;
  }

  const handleFileSelect = function (event) {
    const files = event.target.files;
    postFileData(files);
  };

  const handleDrag = function (event) {
    event.preventDefault();
  };

  const handleDrop = function (event) {
    event.preventDefault();
    const files = event.dataTransfer.files;
    postFileData(files);
  };

  function postFileData(files) {
    const valid = validateFile(files);
    if (valid) {
      const file = files[0];
      if (prevFileData) {
        dispatch(setPreThumbnailId(prevFileId));
        setPrevFileId(prevFileId);
        dispatch(setPrevThumbnailDetails(prevFileData));
        setPreFileData({ photoUrl: null, fileName: null });
      }
      if (file) {
        dispatch(setSelectedFile(file));
        dispatch(fileUpload(file))
          .unwrap()
          .then((res) => {
            setPhotoUrl(res[0]._id);
            setState((prev) => ({ ...prev, photoId: res[0]._id }));
            setPrevFileId(res[0]._id);
          });
      }
    }
  }

  if (errorMessageCode) {
    return (
      <ErrorAlert
        show={errorMessageCode}
        onClickHandle={handleCloseErrorAlert}
        title="Error"
        subTitle={ErrorMessages(errorMessageCode)}
      />
    );
  }

  return (
    <div className="modal">
      <div className="form-scroll">
        <div className="form-flex">
          <div className="user-form-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="form-header">
              <div className="header">{data ? "Update AC Visit Partner" : "Add AC Visit Partner"}</div>
              <CloseButton
                onClickhandle={() => {
                  resetImage();
                  if (data === null) {
                    setState({});
                    setValidation({});
                  }
                  setPreFileData({
                    photoUrl: data?.photoUrl || null,
                    fileName: data?.fileName || null,
                  });
                  setImageDeleteList([]);
                  setErrorSingleMessage("");
                  onClickNext();
                }}
              />
            </div>

            <div className="form-container">
              <div className="form-label-input">
                <label className="form-label">
                  {ConciergeStringLabels.firstName}
                  <Required />
                </label>
                <div className="form-input-container">
                  <input
                    type="text"
                    name="firstName"
                    value={state.firstName}
                    onChange={handleChange}
                    placeholder="Input"
                    className="form-input"
                    required
                  />
                </div>
                <ErrorMessageComponent message={validation.firstName} />
              </div>

              <div className="form-label-input">
                <label className="form-label">{ConciergeStringLabels.lastName}</label>
                <div className="form-input-container">
                  <input
                    type="text"
                    name="lastName"
                    value={state.lastName}
                    onChange={handleChange}
                    placeholder="Input"
                    className="form-input"
                    required
                  />
                </div>
                <ErrorMessageComponent message={validation.lastName} />
              </div>

              <div className="form-label-input">
                <label className="form-label">
                  {ConciergeStringLabels.email}
                  <Required />
                </label>
                <div className="form-input-container">
                  <input
                    type="text"
                    name="email"
                    value={state.email}
                    onChange={handleChange}
                    placeholder="Input"
                    className="form-input"
                    required
                  />
                </div>
                <ErrorMessageComponent message={validation.email} />
              </div>
          
              {!disableFields && (
                <>
                  <div className="form-label-input">
                    <label className="form-label">
                      {ConciergeStringLabels.aboutMe}
                      <Required />
                    </label>
                    <div className="user-form-input-container">
                      <textarea
                        name="aboutMe"
                        value={state.aboutMe}
                        onChange={handleChange}
                        placeholder="Input"
                        className="form-input"
                        rows={3}
                      />
                    </div>
                    <ErrorMessageComponent message={validation.aboutMe} />
                  </div>
                  <div className="form-label-input">
                    <label className="form-label">{ConciergeStringLabels.ccEmails}</label>
                    <div className="user-form-input-container">
                      <textarea
                        name="ccEmails"
                        value={state.ccEmails}
                        onChange={handleChange}
                        placeholder="Input"
                        className="form-input"
                        rows={3}
                      />
                    </div>
                    <ErrorMessageComponent message={validation.ccEmails} />
                  </div>
                </>
              )}

              <FileUploader
                previewShape="circular"
                headerName="AC Visit Partner Photo"
                handleDragOver={handleDrag}
                handleDrop={handleDrop}
                handleFileSelect={handleFileSelect}
                setPreFileData={setPreFileData}
                handleState={handleState}
                type="concierge"
              />

              {errorSingleMessage && (
                <p className="error image-error">{errorSingleMessage}</p>
              )}

              {prevFileData?.photoUrl && data?.photoUrl && data?.fileName && (
                <ImagePreviewWithFilename
                  photoUrl={data.photoUrl}
                  fileName={data.fileName}
                  previewShape="circular"
                  handleCancel={handleImageCancel}
                />
              )}

              <div className="footer-button-container">
                <CancelButton
                  onClickhandle={() => {
                    resetImage();
                    if (data === null) {
                      setState({});
                      setValidation({});
                    }
                    setPreFileData({
                      photoUrl: data?.photoUrl || null,
                      fileName: data?.fileName || null,
                    });
                    setImageDeleteList([]);
                    setErrorSingleMessage("");
                    onClickNext();
                  }}
                >
                  {ConciergeStringLabels.cancel}
                </CancelButton>
                <BlackButton onClickhandle={() => handleCreateButton()}>
                  {data
                    ? ConciergeStringLabels.update
                    : ConciergeStringLabels.add}
                </BlackButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddConciergeForm;